export default __webpack_public_path__ + "media/images/backgrounds/bg-03-1918x761-9b50decc989a685a8d619104ccc17a7d.jpg";